<!-- Modern Professional Layout -->
<div class="layout-container">

  <!-- Main Content Area -->
  <div class="main-content">

    <!-- Header -->
    <app-header data-nav-header></app-header>

    <!-- Page Content -->
    <main class="page-content">
      <app-content></app-content>
    </main>

    <!-- Footer -->
    <app-footer></app-footer>

  </div>

</div>

<!-- Full-Screen Navigation Modal -->
<app-nav-modal></app-nav-modal>
